var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.uiClass(), attrs: { id: "app" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c("vue-progress-bar"),
      _vm._v(" "),
      _vm.missingDeviceData
        ? _c("device-missing", {
            ref: "missingDevice",
            attrs: { profile: _vm.missingDeviceData },
            on: { "close-missing": _vm.closeMissing },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }